import React from "react";
import { LogIn, UserRound } from "lucide-react";

export default function AuthButton({ user, onLogin, onAccount }) {
  const label = user ? "Личный кабинет" : "Войти";
  const avatarUrl = user?.avatar?.trim() ? user.avatar : null;
  const baseClasses = "inline-flex items-center text-sm text-slate-600 hover:text-slate-900";
  const classes = user ? `${baseClasses} h-8 w-8 justify-center rounded-full` : `${baseClasses} gap-2`;

  return (
    <button
      onClick={user ? onAccount : onLogin}
      className={classes}
      aria-label={label}
      title={label}
      type="button"
    >
      {user ? (
        avatarUrl ? (
          <img
            src={avatarUrl}
            alt=""
            className="h-7 w-7 rounded-full object-cover"
            aria-hidden="true"
          />
        ) : (
          <UserRound className="h-5 w-5" aria-hidden="true" />
        )
      ) : (
        <>
          <LogIn className="hidden md:block h-5 w-5" aria-hidden="true" />
          <span>{label}</span>
        </>
      )}
    </button>
  );
}
